import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackPopupAgree, trackPopupClose, trackPopupShow } from './tracking';
import { setLocationCookies } from '../../../browser/utils/location';
import { EPopupType, openPopup } from '../../actions/geoLocation';
import { RegionSelectCall } from '../../components/RegionSelectCall';
import { selectIsRegionSelected } from '../../selectors/geoLocation';
import { selectCurrentRegion } from '../../selectors/regions';
import { TThunkDispatch } from '../../types/redux';
import { useApplicationContext } from '../ApplicationContext';

export const RegionSelectCallContainer = () => {
  const { config } = useApplicationContext();
  const dispatch = useDispatch<TThunkDispatch>();

  const isRegionSelectCallFromHeaderEnabled = config.get<boolean>('header-frontend.regionSelectCall.Enabled') ?? false;
  const isRegionSelectCallEnabled = config.get<boolean>('regionSelectCall.Enabled') ?? false;

  const isRegionSelected = useSelector(selectIsRegionSelected);

  const { name, id, mainTownId } = useSelector(selectCurrentRegion);

  const [opened, setOpened] = React.useState(!isRegionSelected);

  const handleClose = useEventCallback(() => {
    trackPopupClose(name);
    setOpened(false);
  });

  const handleAgree = useEventCallback(() => {
    setLocationCookies(id, name, mainTownId);
    trackPopupAgree(name);
    setOpened(false);
  });

  const handleRegionChange = useEventCallback(() => {
    dispatch(openPopup(EPopupType.GeoChanger));
  });

  const handlePopupShow = useEventCallback(() => {
    trackPopupShow(name);
  });

  if (isRegionSelectCallFromHeaderEnabled || !isRegionSelectCallEnabled || !opened) {
    return null;
  }

  return (
    <ActionAfterViewObserver triggerOnce callback={handlePopupShow} wrapper={false}>
      <RegionSelectCall
        regionName={name}
        onClose={handleClose}
        onAgree={handleAgree}
        onRegionChange={handleRegionChange}
      />
    </ActionAfterViewObserver>
  );
};
